module.exports = __webpack_public_path__ + "img/guide_1_3.fbc572ed.svg";